var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,20.3C15.9,20.3,20,14,20,8.6c0-0.2,0-0.4,0-0.5c0.8-0.6,1.5-1.3,2.1-2.1c-0.8,0.3-1.5,0.6-2.4,0.6 c0.9-0.5,1.5-1.3,1.8-2.3c-0.8,0.5-1.7,0.8-2.6,1c-1.6-1.7-4.2-1.7-5.8-0.2c-1.1,1-1.5,2.5-1.2,3.9C8.6,8.9,5.5,7.3,3.4,4.8 C2.3,6.6,2.9,9,4.7,10.2C4,10.2,3.4,10,2.8,9.7c0,0,0,0,0,0.1c0,2,1.4,3.6,3.3,4C5.5,14,4.9,14,4.3,13.9c0.5,1.7,2.1,2.8,3.8,2.9 c-1.5,1.1-3.3,1.8-5.1,1.8c-0.3,0-0.7,0-1-0.1C3.9,19.7,6.1,20.3,8.3,20.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9fecca042727aad8c93db253cd30a38d.svg";
export { ForwardRef as ReactComponent };